import React from 'react'
import cx from 'classnames'

import s from './Card.scss'


const Card = ({ children, className, onClick }) => (
  <div className={cx(s.card, className)} onClick={onClick}>
    {children}
  </div>
)


export default Card
